export const CRISIS_HELP_REPLY =
  'If you are in crisis or thinking about harming yourself, stop using ClubIQ and get help now. In the United States, call or text 988. ClubIQ is a golf app and cannot help with this.';

const CRISIS_PATTERNS = [
  /kill myself/i,
  /killing myself/i,
  /end my life/i,
  /take my (own )?life/i,
  /want to die\b/i,
  /suicid(e|al)/i,
  /self[-\s]?harm/i,
  /hurt myself/i,
  /cut myself/i,
  /hang myself/i,
  /overdose/i,
  /don't want to (be here|live)/i,
  /dont want to (be here|live)/i,
];

export function userTextRequestsCrisisHelp(text: string): boolean {
  const value = (text || '').trim();
  if (!value) return false;
  return CRISIS_PATTERNS.some((pattern) => pattern.test(value));
}

export function extractUserTextFromChat(messages: Array<{ role?: string; content?: unknown }>): string {
  const parts: string[] = [];
  for (const message of messages || []) {
    if (message?.role !== 'user') continue;
    const content = message.content;
    if (typeof content === 'string') {
      parts.push(content);
      continue;
    }
    if (!Array.isArray(content)) continue;
    for (const part of content) {
      if (part && typeof part === 'object' && 'text' in part && typeof (part as { text?: string }).text === 'string') {
        parts.push((part as { text: string }).text);
      }
    }
  }
  return parts.join('\n');
}

export const AI_SAFETY_SYSTEM = `SAFETY: If the user expresses suicidal thoughts or self-harm, do not give golf advice. Reply only with: ${CRISIS_HELP_REPLY}`;
